import React, {useMemo} from 'react';
import {Text, TableColumnConfig} from '@gravity-ui/uikit';
import {DataTable, formatDateTimeToLocal} from '../../../../../shared';
import {BenefactorSubscriptionModel, CancellationReason} from '../../../model';
import styles from './CancelledSubscriptions.module.scss';

interface CancelledSubscriptionsProps {
  subscriptions: BenefactorSubscriptionModel[];
  isLoading: boolean;
}

const getCancellationReasonText = (reason: CancellationReason | null): string => {
  if (!reason) return '-';

  switch (reason) {
    case CancellationReason.CancelledByBenefactor:
      return 'Отменено пользователем';
    case CancellationReason.CancelledByAdmin:
      return 'Отменено администратором';
    case CancellationReason.PaymentFailure:
      return 'Ошибка платежа';
    case CancellationReason.Other:
      return 'Другое';
    default:
      return '-';
  }
};

export const CancelledSubscriptions: React.FC<CancelledSubscriptionsProps> = ({subscriptions, isLoading}) => {
  const columns = useMemo<TableColumnConfig<BenefactorSubscriptionModel>[]>(
    () => [
      {
        id: 'cancelledAt',
        name: 'Дата отмены',
        width: 200,
        template: (item) => (
          <Text variant="body-1">{item.cancelledAt ? formatDateTimeToLocal(item.cancelledAt) : '-'}</Text>
        ),
      },
      {
        id: 'cancellationReason',
        name: 'Причина отмены',
        width: 200,
        template: (item) => <Text variant="body-1">{getCancellationReasonText(item.cancellationReason)}</Text>,
      },
      {
        id: 'type',
        name: 'Тип подписки',
        width: 150,
        template: (item) => <Text variant="body-1">{item.type || '-'}</Text>,
      },
    ],
    [],
  );

  return (
    <div className={styles.container}>
      <Text variant="subheader-3" className={styles.title}>
        Отмененные подписки
      </Text>

      <div className={styles.tableContainer}>
        <DataTable
          data={subscriptions}
          columns={columns}
          isLoading={isLoading}
          emptyStateTitle="Нет отмененных подписок"
          emptyStateDescription="Отмененные подписки отобразятся здесь"
        />
      </div>
    </div>
  );
};
